import { render, staticRenderFns } from "./myTouchNav.vue?vue&type=template&id=36e0d85c&scoped=true&"
import script from "./myTouchNav.vue?vue&type=script&lang=js&"
export * from "./myTouchNav.vue?vue&type=script&lang=js&"
import style0 from "./myTouchNav.vue?vue&type=style&index=0&id=36e0d85c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e0d85c",
  null
  
)

export default component.exports